"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatRelativeTime = exports.formatDate = exports.DateFormatOptions = void 0;
var DateFormatOptions;
(function (DateFormatOptions) {
    DateFormatOptions["DATEONLY"] = "date";
    DateFormatOptions["DATEANDTIME"] = "date-and-time";
})(DateFormatOptions || (exports.DateFormatOptions = DateFormatOptions = {}));
const formatDate = (date, format = DateFormatOptions.DATEANDTIME) => {
    if (!date)
        return 'Never';
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return dateObj.toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        ...(format === DateFormatOptions.DATEANDTIME && {
            hour: '2-digit',
            minute: '2-digit',
        }),
    });
};
exports.formatDate = formatDate;
const formatRelativeTime = (dateInput) => {
    let date;
    if (typeof dateInput === 'string') {
        const dateStr = dateInput.endsWith('Z') ? dateInput : `${dateInput}Z`;
        date = new Date(dateStr);
    }
    else {
        date = dateInput;
    }
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    if (diffMs < 0)
        return 'just now';
    const diffSecs = Math.floor(diffMs / 1000);
    const diffMins = Math.floor(diffSecs / 60);
    const diffHours = Math.floor(diffMins / 60);
    const diffDays = Math.floor(diffHours / 24);
    const diffMonths = Math.floor(diffDays / 30);
    const diffYears = Math.floor(diffDays / 365);
    if (diffSecs < 60)
        return 'just now';
    if (diffMins === 1)
        return '1 minute ago';
    if (diffMins < 60)
        return `${diffMins} minutes ago`;
    if (diffHours === 1)
        return '1 hour ago';
    if (diffHours < 24)
        return `${diffHours} hours ago`;
    if (diffDays === 1)
        return '1 day ago';
    if (diffDays < 30)
        return `${diffDays} days ago`;
    if (diffMonths === 1)
        return '1 month ago';
    if (diffMonths < 12)
        return `${diffMonths} months ago`;
    if (diffYears === 1)
        return '1 year ago';
    return `${diffYears} years ago`;
};
exports.formatRelativeTime = formatRelativeTime;
